import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router'; 
import { ITicketDetails } from 'src/app/trip-view-cab/services/common-cab.service';
import { DataService } from 'src/app/data.service';
import { DateUtils } from 'src/app/utils/days-utils';



@Injectable({
  providedIn: 'root'
})
export class CommonService {
  this: any;

  constructor(
    private http: HttpClient,
    private router: Router
    ) { }
  employeeDetails$ = new BehaviorSubject<any>([]);
  busStopsDetails$ = new BehaviorSubject<any>([]);
  driverActions$ = new BehaviorSubject<any>([]);
  attendance$ = new BehaviorSubject<any>(
    {
      adhocCount: 0,
      noShowCount: 0,
      totalPlannedEmployeesToBoard: 0,
      plannedemployeesBoarded: 0,
      totalCapacity: 0,
      totlaPlannedEmployees:0
    });
  womenTravellingAlone$=new BehaviorSubject<boolean>(false);
  response: any;
  loader: any = true;
  buid: any;
  NONCE_TOKEN: any;
  tripId: any;
  dutyId: any;
  dutyUuid: any;
  cabId: any;
  source: any='';
  routeSource: any;
  date: any;
  timeZone='Asia/Kolkata';
  geofenceRadius:any;
  ticketDetails:ITicketDetails[] = []
  tripDetails:any;
  dataService = inject(DataService);
  hasDeviceImei: boolean = true;
  private safetyAlertSubject = new BehaviorSubject<[]>([]);;
  safetyAlert$ = this.safetyAlertSubject.asObservable();
  goToTripReplay(){
    this.router.navigate(['trip-view/trip-replay'], {queryParams:{buid:this.buid, tripId: this.tripId, ...(this.source ? { source: this.source } : {})}});
  }

  getTripStatus(tripId: string){
    return this.http.get(`${environment.API_URL}/ets/${this.buid}/trip-status/${tripId}`);
  }

  getTripDetails(tripId: any) {
      return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/trip/${tripId}`).pipe(
      tap((response) => {
        this.dutyId = response?.['dutyId'];
        this.tripDetails = response?.['tripDetails'];
        this.dutyUuid = response?.['dutyUuid'];
        this.tripId = response?.['tripDetails']?.['tripId'];
        this.cabId = response?.['tripDetails']?.['vehicle']?.['cabId'];
        this.routeSource = response?.['tripDetails']?.['routeSource'];
        this.date = DateUtils.formatDate(response['tripDetails']['shift']['date'], 'DD/MM/YYYY');
        this.hasDeviceImei = response?.['tripDetails']?.['vehicle']?.['deviceDTO']?.imei ? true : false;
        this.safetyAlertSubject.next(response?.['tripDetails']?.['safetyAlert']);
     }))
  }

  getDeviceHealth(date: any, deviceId: any, deviceImei: any) {

    let formattedDate = DateUtils.customFormatDate(date, 'MMM DD, YYYY', 'DD-MM-YYYY');

    return this.http.get(`${environment.API_URL}/healthlogs?buid=${this.buid}&date=${formattedDate}&deviceId=${deviceId}&deviceImei=${deviceImei}`)
  }

  getDriverActions(tripUUID?: any, tripId?: any) {
    //https://mis-central-stag.moveinsync.com/centralized-dashboard/tracking/buid/qa-Test3/get-driver-action?tripUUID=b3e69182-66e0-4cdf-a2d4-f39d19a3f6e3&tripId=858398

    return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/get-driver-action?tripUUID=${tripUUID}&tripId=${tripId}`)
  }

  getTrackingSession(legUUID: any, sequenceId: any, imei: any, dataSource: any,isCompletedTrip:boolean,isFixedDevice:boolean, tripId: any) {
    const IMEI = this.getDeviceIMEI(isFixedDevice)
    return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/get-tracking-data?legUUID=${legUUID}&suquenceId=${sequenceId}&imei=${IMEI}&isCompletedTrip=${isCompletedTrip}&isFixedDevice=${isFixedDevice}&tripId=${tripId}` )
  }

  getDeviceIMEI(isFixedDevice:boolean){
    const vehicle = this.tripDetails?.vehicle;
    if (!vehicle) {
      return null;
   }
    return isFixedDevice? 
     vehicle?.externalDeviceImei :
     vehicle?.deviceDTO?.imei
 }


  getGeofence() {
    return this.http.get(`${environment.CONFIGURATION_SERVICE_API}/DRIVER_APP/properties/buid/${this.buid}/property/LOGIN_TRIP_OVER_DISTANCE`);
//    return of({
//     "LOGIN_TRIP_OVER_DISTANCE": "75"
// })
  }
  getGeofencePoints(){
    return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/trip/${this.tripId}`);
  }

  nextTripDetails(nextTripGuid:any){
    return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/get-next-tripdata?tripGuid=${nextTripGuid}`)
  }

  getTimeZone(){
    return this.http.get(`${environment.API_URL}/ets/${this.buid}/timeZone`);
  }
  createOldRoute() {
    const buid = this.dataService.ETS_BUID;
    if (window.parent.location.href.includes('.moveinsync.in')) {
       if(this.NONCE_TOKEN) {
          return `https://${buid.split('-')[0]}.moveinsync.in/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}&CSRF_NONCE=${this.NONCE_TOKEN}`;
       }
       return `https://${buid.split('-')[0]}.moveinsync.in/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}`;
    }
    if(this.NONCE_TOKEN) {
       return `https://${buid.split('-')[0]}.moveinsync.com/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}&CSRF_NONCE=${this.NONCE_TOKEN}`;
    }
    return `https://${buid.split('-')[0]}.moveinsync.com/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}`;
 }
  
  isDutyIdPresent(){
    return !!this.dutyId?true:false;
   }

   getEtsUrl()
   {
      return this.http.get(environment.API_URL+"/dashboard/"+this.buid+"/url",{ responseType: 'text' })
   }

   getTicketDetails(){
    return this.http.get(`${environment.API_URL}/ticketing/ticket/trip-view/${this.buid}/${this.tripId}`)
 }

  getDeviceInfo(){
    const headers = new HttpHeaders({
      'X-tenantID' : this.buid
    })
    return this.http.get(`${environment.API_URL}/tripdeviceinfo?dutyId=${this.dutyId}&buid=${this.buid}&dutyUuid=${this.dutyUuid}&tripId=${this.tripId}`, {headers: headers})

  }
  getReleaseNotesData() {
    const name = 'Driver Device Versions';
    return this.http.get(`${environment.API_URL}/releaseNotes`).pipe(
      map((notes: any[]) => notes.find((note: any) => note.name.includes(name)))
    );
  }

  getUnknownRfidData(){
    return this.http.get(`${environment.API_URL}/events/orphan-and-unmapped/trip/${this.tripId}`);
    return of([{"stwid":25574,"name":"Vaibhav","gender":"MALE","signinTimeStamp":1740655558904,"signoutTimeStamp":1740655690671,"tag":null,"type":"ORPHAN"},{"stwid":25574,"name":"Vaibhav","gender":"MALE","signinTimeStamp":1740655558906,"signoutTimeStamp":1740655690673,"tag":null,"type":"ORPHAN"},{"stwid":null,"name":null,"gender":null,"signinTimeStamp":1740655558904,"signoutTimeStamp":1740655558904,"tag":"TAG100001","type":"UNMAPPED"},{"stwid":null,"name":null,"gender":null,"signinTimeStamp":1740655558904,"signoutTimeStamp":1740655558904,"tag":"TAG100001","type":"UNMAPPED"},{"stwid":null,"name":null,"gender":null,"signinTimeStamp":1740655558904,"signoutTimeStamp":1740655558904,"tag":"TAG100002","type":"UNMAPPED"}])
  }

  updateAttendance(payload:any) {
    return this.http.post(`${environment.API_URL}/attendance/process`, payload)
  }
}
